import { render, staticRenderFns } from "./OfficeTimeTrackerView.vue?vue&type=template&id=520c2ca8&scoped=true"
import script from "./OfficeTimeTrackerView.vue?vue&type=script&lang=js"
export * from "./OfficeTimeTrackerView.vue?vue&type=script&lang=js"
import style0 from "./OfficeTimeTrackerView.vue?vue&type=style&index=0&id=520c2ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520c2ca8",
  null
  
)

export default component.exports